module.exports = __webpack_public_path__ + "img/nextText.c29a373f.svg";